import { get } from "lodash";
import * as R from "ramda";

export default function resolveProps(column, event = {}) {
  if (column.type === "datetime") {
    return {
      column,
      timezone:
        R.path(["settings", "timezone"], column) || R.prop("timezone", event),
      format: R.path(["settings", "format"], column)
    };
  } else if (
    column.type === "dropdown" &&
    column.settings &&
    column.settings.allowMultipleSelect
  ) {
    return {
      options: get(column, "settings.options", []),
      clearable: get(column, "settings.clearable", true)
    };
  } else if (column.type === "dropdown") {
    return {
      options: get(column, "settings.options", []),
      clearable: get(column, "settings.clearable", true)
    };
  } else if (column.type === "radio") {
    return {
      options: get(column, "settings.options", [])
    };
  } else if (column.type === "percent") {
    return {
      format: get(column, "settings.percentFormat", ""),
      placeholder: get(column, "placeholder", "Enter %")
    };
  } else if (column.type === "currency") {
    return get(column, "settings", {});
  } else if (column.type === "lookup") {
    return get(column, "settings", {});
  } else if (column.type === "reference") {
    return {
      eventId: get(event, "id")
    };
  }

  return { column };
}
